export default __webpack_public_path__ + "static/media/businesscycle-nfo-banner.9ef5b1ed.png";